import { render, staticRenderFns } from "./roomIndex.vue?vue&type=template&id=e8b2b210"
import script from "./roomIndex.vue?vue&type=script&lang=js"
export * from "./roomIndex.vue?vue&type=script&lang=js"
import style0 from "./roomIndex.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports